import React from "react"
import {formatTextTestIds} from "@next/utils"
import {createFilterOptions} from "@mui/material/Autocomplete"
import {SearchValue} from "ducks/viewAllModal"
import {TextModel} from "models/Text"
import {FacetSearchAutocomplete, AutocompleteContainer} from "./components"
import connect from "./connect"
import {FacetsState} from "../../models/FacetsState"
import {Filters} from "../../models/Filter"
import {FilterSearchInput} from "../filterSearchInput"
import {useAutocompleteFacetSearch} from "./useAutocompleteFacetSearch"

interface FacetSearchProps {
    facets: FacetsState
    searchFacets: SearchValue[]
    handleSetFacetModal: (facetValue: string) => void
    displayName: string
    text: TextModel
    filters: Filters
}

const getOptionLabel = (option: any) => ((option as SearchValue).n ? (option as SearchValue).n : "")
const filterOptions = createFilterOptions({
    matchFrom: "start",
})

export const FacetSearch = ({
    facets,
    searchFacets,
    handleSetFacetModal,
    displayName,
    text,
    filters,
}: FacetSearchProps) => {
    const {facetValue, inputString, setSearchString, setFacetValue} = useAutocompleteFacetSearch(
        facets,
        filters,
        handleSetFacetModal,
    )

    return (
        <AutocompleteContainer>
            <FacetSearchAutocomplete
                id="facet-search"
                value={facetValue}
                inputValue={inputString}
                onInputChange={setSearchString}
                autoHighlight
                disablePortal
                filterOptions={filterOptions}
                options={searchFacets}
                onChange={setFacetValue}
                data-testid={formatTextTestIds("plp-facet-search")}
                getOptionLabel={getOptionLabel}
                renderInput={params => <FilterSearchInput params={params} displayName={displayName} text={text} />}
                noOptionsText={text.pages.viewAllModal.noResults}
            />
        </AutocompleteContainer>
    )
}

export default connect(FacetSearch)
